import React, { Suspense, lazy, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import { VehiclesProvider } from "./context/VehiclesContext";
import { auth } from "./lib/firebase";
import { trackPageView } from "./lib/analytics";
import NotFound from "./Pages/NotFoundPage";
import Home from "./Pages/Home";
import AdminLogin from "./module/admin/pages/AdminLogin";
import AboutUs from "./Pages/AboutUs";
import BlogCompo from "./Pages/Blog";
import BlogDetail from "./components/BlogDetails";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import EZRentToOwn from "./Pages/EZRentToOwn";
import RequestQuote from "./Pages/RequestQuote";
import Suburbs from "./Pages/Suburbs";
import SuburbLanding from "./Pages/SuburbLanding";
import { suburbs } from "./data/suburbs";

const AdminRoutes = lazy(() => import("./routes/AdminRoutes"));

const PageLoader = () => (
  <div
    style={{
      minHeight: "40vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    Loading...
  </div>
);

export { auth };

function App() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return (
    <ErrorBoundary>
      <VehiclesProvider>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route index path="/" element={<Home />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="blog" element={<BlogCompo />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="ezrent-to-own" element={<EZRentToOwn />} />
            <Route path="request-quote" element={<RequestQuote />} />
            <Route path="suburbs" element={<Suburbs />} />
            {suburbs.map((suburb) => (
              <Route
                key={suburb.slug}
                path={`car-rental-${suburb.slug}`}
                element={<SuburbLanding />}
              />
            ))}
            <Route path="admin-login" element={<AdminLogin />} />
            <Route
              path="admin-dashboard/*"
              element={
                <ProtectedRoute>
                  <AdminRoutes />
                </ProtectedRoute>
              }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </VehiclesProvider>
    </ErrorBoundary>
  );
}

export default App;
